import { Car, Check } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'

const CHECKLIST_ITEMS = [
  'Managing your claim from start to finish',
  'Reviewing claim information and supporting documentation',
  'Communicating with lenders and finance providers',
  'Monitoring regulatory and legal developments',
  'Preparing your claim for the next stage',
]

const WorkChecklist = () => {
  return (
    <Card className="border-foreground/15 rounded-2xl border bg-[#F1F1F1]">
      <CardContent className="flex gap-4 px-4 py-5 sm:px-6">
        <div className="min-w-0 flex-1">
          <h2 className="text-foreground mb-3 flex items-center gap-2 text-lg font-bold sm:text-xl">
            <Car
              className="size-5 shrink-0 text-[#ff914d]"
              aria-hidden="true"
            />
            The work we are doing for you
          </h2>
          <ul className="space-y-2.5">
            {CHECKLIST_ITEMS.map(item => (
              <li
                key={item}
                className="text-foreground/90 flex items-start gap-2.5 text-sm leading-relaxed sm:text-base"
              >
                <Check
                  className="mt-0.5 size-4 shrink-0 text-[#ff914d]"
                  aria-hidden="true"
                />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </CardContent>
    </Card>
  )
}

export default WorkChecklist
